module.exports = __webpack_public_path__ + "img/logo-horizontal.1508fcb0.png";